import { render, staticRenderFns } from "./ListSpek.vue?vue&type=template&id=63052091&"
import script from "./ListSpek.vue?vue&type=script&lang=js&"
export * from "./ListSpek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports